import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/app.css';
import './styles/board.css';
import './styles/notes.css';
import { AppProvider } from './state/AppState.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import App from './App.jsx';

// The boundary wraps AppProvider, not just App: a throw inside the provider's
// own render would otherwise escape and blank the page, which is exactly the
// failure this is here to prevent.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </ErrorBoundary>
  </StrictMode>,
);
